export const SettingsPageEvents ={
    'TRIGGER_EMAIL_VERIFICATION' :{
        event:'trigger Email verification email settings page',
        action:'Clicked on verify email button and successfully triggered a verification email to be sent to the user'
    },
    'COPY_WORKSPACE_INVITE_LINK':{
        event:'copy workspace invite link from settings view',
        action:'Clicked on Copy Workspace Invite Link button under Workspace Settings'
    },
    'COPY_NOTES_URL':{
        event:'copy notes URL from settings view',
        action:'Clicked on Copy Notetakibg Link button under Notetaking Link section under Settings'
    },
    'RENAME_WORKSPACE':{
        event:'rename workspace from settings page',
        action:'Clicked on rename workspace button under Workspace Settings and successfully renamed the workspace'
    },
    'TOGGLED_AUTO_RECORD_EXTERNAL_ON':{
        event:'toggled auto record external call setting on from settings view',
        action:'Toggeld auto record external call setting on from settings view using the toggle switch'
    },
    'TOGGLED_AUTO_RECORD_EXTERNAL_OFF':{
        event:'toggled auto record external call setting off from settings view',
        action:'Toggeld auto record external call setting off from settings view using the toggle switc'
    },
    'TOGGLE_WORKSPACE_INVITE_LINK_TO_VIEWER':{
        event:'toggle workspace invite link to viewer',
        action:'Clicked on Can edit workspace menu and toggled it to Can view workspace'
    },
    'TOGGLE_WORKSPACE_INVITE_LINK_TO_EDITOR':{
        event:'toggle workspace invite link to editor',
        action:'Clicked on Can view workspace menu and toggled it to Can edit workspace'
    },
    'CLICKED_CREATE_NEW_LABEL_GROUP_ON_SETTINGS_PAGE' :{
        event:'Clicked create new label group cta on settings page',
        action:'Clicked create new label group cta to create new label group from settings page'
    },
    'CREATED_NEW_LABEL_GROUP_FROM_SETTINGS_PAGE' :{
        event:'Created new label group from settings page',
        action:'Created new label group from settings page'
    },
    'ADD_VALUE_TO_LABEL_FROM_SETTINGS_PAGE' :{
        event:'Add value to label from settings page',
        action:'Add a new value to label group from settings page'
    },
    'EDIT_VALUE_OF_LABEL_FROM_SETTINGS_PAGE' :{
        event:'Edit value of label from settings page',
        action:'Edit value of a label group from settings page'
    },
    'DELETE_VALUE_OF_LABEL_FROM_SETTINGS_PAGE' :{
        event:'Delete value of label from settings page',
        action:'Delete value of a label group from settings page'
    },
    'EDIT_LABEL_FROM_SETTINGS_PAGE' :{
        event:'Edit label from settings page',
        action:'Edit text of a from settings page'
    },
    'DELETE_PENDING_WORKSPACE_INVITE' :{
        event:'Delete pending workspace invite from settings page',
        action:'Delete pending workspace invite from settings page'
    },
    
    
}